import { Component, createRef } from "react";
import { FloatButton, Tooltip } from "antd";
import {
  BellOutlined,
  CustomerServiceOutlined,
  DesktopOutlined,
  LoadingOutlined,
  ReloadOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
class InstallPWAButton extends Component {
  deferredPrompt = null;

  constructor(props) {
    super(props);
    // สร้าง Ref เพื่ออ้างอิงปุ่มแทนการใช้ getElementById
    this.myButtonRef = createRef();
    this.state = {
      showInstallButton: false,
    };
  }
  componentDidMount() {
    this.checkInstallationStatus();

    window.addEventListener(
      "beforeinstallprompt",
      this.handleBeforeInstallPrompt,
    );
    window.addEventListener("appinstalled", this.handleAppInstalled);
  }


  componentWillUnmount() {
    window.removeEventListener(
      "beforeinstallprompt",
      this.handleBeforeInstallPrompt,
    );
    window.removeEventListener("appinstalled", this.handleAppInstalled);
  }

  handleBeforeInstallPrompt = (event) => {
    event.preventDefault();
    this.deferredPrompt = event;
    console.log("beforeinstallprompt event fired.");
    if (!this.isPWAInstalled()) {
      this.setState({ showInstallButton: true });
    }
  };
  handleAppInstalled = () => {
    console.log("PWA was successfully installed.");
    this.setState({ showInstallButton: false });
    sessionStorage.setItem("alert-add-home-app", "installed");
  };
  isPWAInstalled = () => {
    if (window.matchMedia("(display-mode: standalone)").matches) {
      return true;
    }
    if ("standalone" in navigator && navigator.standalone) {
      return true;
    }
    if (sessionStorage.getItem("alert-add-home-app") === "installed") {
      return true;
    }
    return false;
  };
  checkInstallationStatus = () => {
    if (this.isPWAInstalled()) {
      this.setState({ showInstallButton: false });
    } else {
      if (this.deferredPrompt) {
        this.setState({ showInstallButton: true });
      }
    }
  };

  showInstallPrompt = () => {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        this.deferredPrompt = null;
        this.checkInstallationStatus();
      });
    } else {
      console.log("Deferred prompt not available or already used.");
      this.setState({ showInstallButton: false });
    }
  };
  render() {
    const { showInstallButton } = this.state;
    const { handleChang, handleOpenModelTicket, isModalOpen } = this.props;
    return (
      <div>
        {/* แสดงปุ่มเมื่อ showInstallButton เป็น true */}

        <FloatButton.Group shape="circle" style={{ bottom: 80 }}>
          <FloatButton.Group
            trigger="click"
            placement="left"
            icon={<ToolOutlined />}
            style={{ bottom: 100 }}
          >
            <>
              <FloatButton
                onClick={() => window.location.reload()}
                icon={
                  <Tooltip title={"รีเฟรช"} placement="top">
                    <ReloadOutlined />
                  </Tooltip>
                }
              />
              <FloatButton
                onClick={() => handleChang(true)}
                icon={
                  <Tooltip title={"ตั้งค่าแจ้งเตือนยอดเงิน"} placement="top">
                    <BellOutlined />
                  </Tooltip>
                }
              />
            </>

            {showInstallButton ? (
              <FloatButton
                onClick={this.showInstallPrompt}
                icon={
                  <Tooltip title={"Install App"} placement="left">
                    <DesktopOutlined />
                  </Tooltip>
                }
              />
            ) : null}
          </FloatButton.Group>

          <FloatButton
            style={{ display: "none" }}
            type="primary"
            icon={
              isModalOpen ? <LoadingOutlined /> : <CustomerServiceOutlined />
            }
            onClick={handleOpenModelTicket}
          />
        </FloatButton.Group>

      </div>
    );
  }
}
export default withRouter(connect(null, {})(InstallPWAButton));
